import React from 'react'
import { useStyles } from './style'
import { Loading } from '../Loading/Loading'

export interface DocumentPrintProps {
  documentPDF: string
  type?: 'base64'
}

export const DocumentPrint: React.FC<DocumentPrintProps> = ({
  documentPDF,
  type
}) => {
  const classes = useStyles()

  if (documentPDF.length <= 0) {
    return <Loading />
  }

  return (
    <iframe
      className={classes.modalPDF}
      src={
        type === 'base64'
          ? `data:application/pdf;base64,${documentPDF}`
          : `${documentPDF}`
      }
      title='html-preview'
      allowFullScreen
      allowTransparency
      id='printViewer'
    >
      {documentPDF}
    </iframe>
  )
}
